var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 11,
    r: 9.75,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1133 6.55498C9.92539 6.64131 9.75781 6.81904 9.68672 7.00693C9.65117 7.09834 9.63086 7.70772 9.63086 8.64209V10.1351L8.06172 10.1503C6.56367 10.1655 6.48242 10.1706 6.35039 10.2722C6.08125 10.4702 6 10.6327 6 10.9526C6 11.2726 6.08125 11.4351 6.35039 11.6331C6.48242 11.7347 6.56367 11.7397 8.05664 11.755L9.62578 11.7702L9.64102 13.3394C9.65625 14.8323 9.66133 14.9136 9.76289 15.0456C9.96094 15.3147 10.1234 15.396 10.4434 15.396C10.7633 15.396 10.9258 15.3147 11.1238 15.0456C11.2254 14.9136 11.2305 14.8323 11.2457 13.3394L11.2609 11.7702L12.8301 11.755C14.323 11.7397 14.4043 11.7347 14.5363 11.6331C14.8055 11.4351 14.8867 11.2726 14.8867 10.9526C14.8867 10.6327 14.8055 10.4702 14.5363 10.2722C14.4043 10.1706 14.323 10.1655 12.8301 10.1503L11.2609 10.1351L11.2457 8.56592C11.2305 7.07295 11.2254 6.9917 11.1238 6.85967C11.068 6.7835 10.9613 6.67178 10.8902 6.621C10.7176 6.49404 10.3164 6.4585 10.1133 6.55498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProduct);
export default __webpack_public_path__ + "static/media/addProduct.5d8a4a5edd4a0f09771f3dfead96899a.svg";
export { ForwardRef as ReactComponent };